import { render, staticRenderFns } from "./MainForm.vue?vue&type=template&id=67fde954&scoped=true&lang=true"
import script from "./MainForm.vue?vue&type=script&lang=js"
export * from "./MainForm.vue?vue&type=script&lang=js"
import style0 from "./MainForm.vue?vue&type=style&index=0&id=67fde954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fde954",
  null
  
)

export default component.exports